import {
  SET_HEADER_FIXED,
  TOGGLE_NAVIGATION,
  TOGGLE_COUNTRY_SELECTOR,
  TOGGLE_SEARCH,
} from './types';

export const setHeaderFixed = isPinned => ({
  type: SET_HEADER_FIXED,
  isPinned,
});

export const toggleNavigation = () => ({
  type: TOGGLE_NAVIGATION,
});

export const toggleCountrySelector = isOpen => ({
  type: TOGGLE_COUNTRY_SELECTOR,
  isOpen,
});

export const toggleSearch = isOpen => ({
  type: TOGGLE_SEARCH,
  isOpen,
});
